import script from "./YImage.vue?vue&type=script&setup=true&lang=js"
export * from "./YImage.vue?vue&type=script&setup=true&lang=js"

import "./YImage.vue?vue&type=style&index=0&id=020a24ea&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/线上短信平台/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-020a24ea"]])

export default __exports__